export default "__VITE_ASSET__a6d0bc47__"